/**
 * Reads the System Details sub-links out of the primary nav.
 *
 * Support Requests, Report Entries and Performance Report were three top-level
 * nav entries; they are now one entry, "System Details", whose page lists the
 * three. The list travels on the nav entry rather than being rebuilt here for
 * two reasons: the Performance Report URL points at the previous whole month
 * and is computed server-side (a client copy would go stale on the first of
 * every month), and every title shown to the user should have exactly one
 * source.
 *
 * Degrades to an empty list on anything unexpected. This runs while the nav is
 * still loading as often as not, and a page that throws on a missing entry is
 * worse than one that briefly shows nothing.
 */

export function useSystemDetails() {
    /**
     * @param {Array|null|undefined} primaryNav the nav array from the chrome response
     */
    function readSystemDetailsLinks(primaryNav) {
        if (!Array.isArray(primaryNav)) return [];

        // Found by the presence of `links` rather than by title: the title is
        // display text the server owns and may reword, and matching on display
        // text is how a rename silently empties this page.
        const entry = primaryNav.find(item => Array.isArray(item?.links) && item.links.length > 0);
        if (!entry) return [];

        return entry.links.filter(link => typeof link?.url === 'string' && link.url !== '');
    }

    return { readSystemDetailsLinks };
}

export default useSystemDetails;
